<template>
  <img 
    :src="src" 
    :alt="alt" 
    class="progressive-image"
    :class="[{ 'is-loaded': isLoaded }, customClass]"
    @load="handleLoad"
  />
</template>

<script>
export default {
  name: 'ProgressiveImage',
  props: {
    src: {
      type: String,
      required: true
    },
    alt: {
      type: String,
      default: ''
    },
    customClass: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      isLoaded: false
    }
  },
  watch: {
    src() {
      // Reset loaded state when src changes (important for reused components)
      this.isLoaded = false
    }
  },
  methods: {
    handleLoad() {
      // Small delay to ensure the blur effect is visible during the transition
      requestAnimationFrame(() => {
        this.isLoaded = true
      })
    }
  }
}
</script>

<style scoped>
.progressive-image {
  /* Initial state: Blurred */
  filter: blur(15px);
  /* Use a long transition for the 'clearing' effect */
  
  /* transition: filter 0.8s ease-out, opacity 0.5s ease-out; */
  
  /* Will change will-change to optimize performance */
  will-change: filter, opacity;
}

/* While loading, force opacity to 0 to hide the painting process */
.progressive-image:not(.is-loaded) {
  opacity: 0 !important;
}

/* When loaded, remove blur. Opacity is handled by parent context or defaults to visible */
.progressive-image.is-loaded {
  filter: blur(0);
}
</style>
